import gql from 'graphql-tag';
import { UserAllDataFragment } from '../fragments';

export default gql`
mutation setAdminIpAddress (
    $id: ID!
    $ip_address: String
) {
    setAdminIpAddress (
        id: $id,
        ip_address: $ip_address
    ) {
        ...UserAllDataFragment
    }
}
${UserAllDataFragment}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/mutations/setAdminIpAddress.ts